<template>
  <div class="Knowledge" v-if="terminal == 'pc'">
    <div class="Knowledge_con_bg">
      <div class="Knowledge_center">
        <ModuleTitle :ModuleTitle="Module_title"></ModuleTitle>
        <div class="Knowledge_box">
          <div
            :class="[activeIdx == 1 ? 'activeIdxOpen' : '']"
            class="Knowledge_box_content_center"
            @click="PathFun('sdgsindicators')"
            @mouseenter="activeIdxOpenFun(1)"
          >
            <img src="../../../assets/image/Index/knowledge_base.png" alt />

            <div class="background">
              <div class="txt">
                <p
                  :class="[
                    language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle',
                  ]"
                >{{ $t("Index.Knowledge.Indicators") }}</p>
              </div>
            </div>
          </div>
          <div
            :class="[activeIdx == 2 ? 'activeIdxOpen' : '']"
            @mouseenter="activeIdxOpenFun(2)"
            class="Knowledge_box_content_center"
            @click="PathFun('sdgsreports')"
          >
            <img src="../../../assets/image/Index/knowledge_repot.png" alt />

            <div class="background">
              <div class="txt">
                <p
                  :class="[
                    language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle',
                  ]"
                >{{ $t("Index.Knowledge.Reports") }}</p>
              </div>
            </div>
          </div>
          <div
            :class="[activeIdx == 3 ? 'activeIdxOpen' : '']"
            @mouseenter="activeIdxOpenFun(3)"
            class="Knowledge_box_content_center"
            @click="PathFun('visual')"
          >
            <img src="../../../assets/image/Index/knowledge_data.png" alt />

            <div class="background">
              <div class="txt">
                <p
                  :class="[
                    language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle',
                  ]"
                >{{ $t("Index.Knowledge.TerraViewSDGs") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import util from "@/util/util.js";
import { swiper, swiperSlide, Pagination } from "vue-awesome-swiper";
export default {
  mixins: [mapMixin],

  data() {
    return {
      activeIdx: 1,
      // Module_title: {
      //   name: "knowledge",
      //   more: false,
      //   color: "#fff",
      //   zhTitle: "Knowledge Base",
      //   enTitle: "Knowledge Base",
      // },
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 900000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          init: function() {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function() {},
          slideChangeTransitionEnd: function() {},
          slideChange: function() {
            swiperAnimate(this);
          }
        }
      }
    };
  },
  methods: {
    activeIdxOpenFun(val) {
      this.activeIdx = val;
    },
    PathFun(val) {
      if ("visual" == val) {
        window.open(`${util.baseUrl}/terraview-sdgs`, "_blank");
      } else {
        this.$router.push(`/${val}`);
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    Module_title: function() {
      return {
        name: "knowledge",
        color: "#fff",
        more: false,
        ehTitle: this.$t("Nav.Menu.Knowledgebase"),
        zhTitle: this.$t("Nav.Menu.Knowledgebase")
      };
    }
  },
  components: {
    swiper,
    swiperSlide,
    Pagination,
    ModuleTitle: () =>
      import("../../PublicComponents/ModuleTitle/ModuleTitle.vue")
  }
};
</script>

<style lang="scss">
@media screen and (min-width: 1026px) {
  .zhFamilytitle {
    font-family: $zhFamily;
  }
  .enfamilytitle {
    font-family: $enfamilytitle;
  }
  .Knowledge {
    background: rgba(219, 24, 104, 1);

    width: 100%;
    height: 704px;
    margin-bottom: 8px;
    .Knowledge_con_bg {
      background: url("../../../assets/image/Index/knowledge_bg.png") no-repeat;
      background-size: 100% 100%;
      background-attachment: fixed !important;
    }
    .Knowledge_center {
      overflow: hidden;
      width: 1200px;
      height: 100%;
      margin: 40px auto 0;

      .Knowledge_title {
        display: inline-block;
        margin: 40px 0 30px;
        color: #fff;
        padding: 10px 30px;
        background: #439f38;
      }
    }

    .Knowledge_box {
      padding-top: 30px;
      display: flex;
      flex-direction: row;
      // height: 600px;

      .Knowledge_box_content_left {
        position: relative;
        // background: #ccc;

        flex: 1;
        height: 500px;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        &:hover {
          min-width: 820px;
        }
        &:hover .background {
          height: 150px;
          transition: 0.2s;
        }

        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
          border-radius: 4px;
        }
        &:hover .txt {
          background-size: 100% 2px !important;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: 0.2s;
          border-radius: 4px;
        }

        .background {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 820px;
          height: 300px;

          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
          .txt {
            position: absolute;
            color: #fff;
            padding-bottom: 4px;
            font-weight: 600;
            bottom: 20px;
            left: 20px;
            font-size: 18px;
            background-image: linear-gradient(#fff, #fff);
            background-position: left bottom;
            background-repeat: no-repeat;
            transition: background-size 0.2s
              cubic-bezier(0.55, 0.085, 0.68, 0.53);
            text-decoration: none;
            background-size: 0 2px;
          }
        }
      }
      .activeIdxOpen {
        transition: 0.4s !important;
        width: 1020px !important;
      }
      .Knowledge_box_content_center {
        position: relative;
        // background: #ccc;
        cursor: pointer;
        // width: 180px;
        width: 33%;
        height: 500px;
        margin-left: 8px;
        border-radius: 4px;
        transition: 0.4s;

        overflow: hidden;

        // &:hover {
        //   transition: 0.4s;
        //   width: 1020px;
        // }
        &:hover .background {
          height: 150px;
          transition: 0.2s;
        }

        &:hover img {
          transition: 0.2s;
          // transform: scale(1.1);
          border-radius: 4px;
        }
        &:hover .txt {
          background-size: 100% 2px !important;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          // background-size:cover;
          border-radius: 4px;
          overflow: hidden;
        }
        .background {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 820px;
          height: 100%;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
          .txt {
            position: absolute;
            color: #fff;
            padding-bottom: 4px;
            font-weight: 600;
            bottom: 20px;
            left: 20px;
            font-size: 18px;
            background-image: linear-gradient(#fff, #fff);
            background-position: left bottom;
            background-repeat: no-repeat;
            transition: background-size 0.2s
              cubic-bezier(0.55, 0.085, 0.68, 0.53);
            text-decoration: none;
            background-size: 0 2px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .activeIdxOpen {
    transition: 0.4s !important;
    width: 1020px !important;
  }
  .Knowledge {
    background: rgba(219, 24, 104, 1);

    width: 100%;
    height: 704px;
    margin-bottom: 8px;
    .Knowledge_con_bg {
      background: url("../../../assets/image/Index/knowledge_bg.png") no-repeat;
      background-size: 100% 100%;
      background-attachment: fixed !important;
    }
    .Knowledge_center {
      overflow: hidden;
      width: 1200px;
      height: 100%;
      margin: 40px auto 0;

      .Knowledge_title {
        display: inline-block;
        margin: 40px 0 30px;
        color: #fff;
        padding: 10px 30px;
        background: #439f38;
      }
    }

    .Knowledge_box {
      padding-top: 30px;
      display: flex;
      flex-direction: row;
      // height: 600px;

      .Knowledge_box_content_left {
        position: relative;
        // background: #ccc;
        width: 820px;
        height: 500px;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        &:hover .background {
          height: 150px;
          transition: 0.2s;
        }

        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
          border-radius: 4px;
        }
        &:hover .txt {
          background-size: 100% 2px !important;
        }
        img {
          width: 100%;
          height: 100%;
          transition: 0.2s;
          border-radius: 4px;
        }

        .background {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 300px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
          .txt {
            position: absolute;
            color: #fff;
            padding-bottom: 4px;

            bottom: 20px;
            left: 20px;
            font-size: 18px;
            background-image: linear-gradient(#fff, #fff);
            background-position: left bottom;
            background-repeat: no-repeat;
            transition: background-size 0.2s
              cubic-bezier(0.55, 0.085, 0.68, 0.53);
            text-decoration: none;
            background-size: 0 2px;
          }
        }
      }
      .Knowledge_box_content_center {
        position: relative;
        // background: #ccc;
        cursor: pointer;
        width: 180px;
        height: 500px;
        margin-left: 8px;
        border-radius: 4px;
        overflow: hidden;
        &:hover .background {
          height: 150px;
          transition: 0.2s;
        }

        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
          border-radius: 4px;
        }
        &:hover .txt {
          background-size: 100% 2px !important;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          overflow: hidden;
        }
        .background {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
          .txt {
            position: absolute;
            color: #fff;
            padding-bottom: 4px;

            bottom: 20px;
            left: 20px;
            font-size: 18px;
            background-image: linear-gradient(#fff, #fff);
            background-position: left bottom;
            background-repeat: no-repeat;
            transition: background-size 0.2s
              cubic-bezier(0.55, 0.085, 0.68, 0.53);
            text-decoration: none;
            background-size: 0 2px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .el-carousel__item--card {
    width: 80% !important;
  }
  .Knowledge {
    background: rgba(219, 24, 104, 1);

    width: 100%;
    // height: 704px;
    margin-bottom: 8px;
    .Knowledge_con_bg {
      background: url("../../../assets/image/Index/knowledge_bg.png") no-repeat;
      background-size: 100% 100%;
      background-attachment: fixed !important;
    }
    .Knowledge_center {
      overflow: hidden;
      // width: 100%;
      padding: 10px;
      height: 100%;
      margin: 0px auto 0;

      .Knowledge_title {
        display: inline-block;
        margin: 40px 0 30px;
        color: #fff;
        padding: 10px 30px;
        background: #439f38;
      }
    }

    .Knowledge_box {
      padding-top: 30px;
      display: flex;
      flex-direction: row;
      // height: 600px;

      .Knowledge_box_content_left {
        position: relative;
        // background: #ccc;
        // width: 820px;
        height: 500px;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        &:hover .background {
          height: 150px;
          transition: 0.2s;
        }

        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
          border-radius: 4px;
        }
        &:hover .txt {
          background-size: 100% 2px !important;
        }
        img {
          width: 100%;
          height: 100%;
          transition: 0.2s;
          border-radius: 4px;
        }

        .background {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 820px;
          height: 300px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
          .txt {
            position: absolute;
            color: #fff;
            padding-bottom: 4px;

            bottom: 20px;
            left: 20px;
            font-size: 18px;
            background-image: linear-gradient(#fff, #fff);
            background-position: left bottom;
            background-repeat: no-repeat;
            transition: background-size 0.2s
              cubic-bezier(0.55, 0.085, 0.68, 0.53);
            text-decoration: none;
            background-size: 0 2px;
          }
        }
      }
      .Knowledge_box_content_center {
        position: relative;
        // background: #ccc;
        cursor: pointer;
        width: 180px;
        height: 500px;
        margin-left: 8px;
        border-radius: 4px;
        overflow: hidden;
        &:hover .background {
          height: 150px;
          transition: 0.2s;
        }

        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
          border-radius: 4px;
        }
        &:hover .txt {
          background-size: 100% 2px !important;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          overflow: hidden;
        }
        .background {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 820px;
          height: 100%;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
          .txt {
            position: absolute;
            color: #fff;
            padding-bottom: 4px;

            bottom: 20px;
            left: 20px;
            font-size: 18px;
            background-image: linear-gradient(#fff, #fff);
            background-position: left bottom;
            background-repeat: no-repeat;
            transition: background-size 0.2s
              cubic-bezier(0.55, 0.085, 0.68, 0.53);
            text-decoration: none;
            background-size: 0 2px;
          }
        }
      }
    }

    .swiper-pagination {
      // position: absolute;
      width: 100% !important;
      height: 50px;
      bottom: 140px;
      justify-content: flex-start;
      display: flex;
      flex-direction: row;
    }
  }
}
</style>
